import React from 'react'; // eslint-disable-line

const AppWrapper = (props) => {
    return (
        <div className="app-intro-wrapper intro_projects-dashboard">
            <div className="app-intro-wrapper-inside">
                {props.children}
            </div>
        </div>
    );
};
export default AppWrapper;
